import { createRouter, createWebHashHistory } from 'vue-router'
import Index from '../views/Index.vue'
import AllList from '../views/AllList.vue'

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  }, {
    path: '/list/:phone/:code',
    name: 'List',
    component: AllList
    // children: [{
    //   name: 'all',
    //   path: 'all',
    //   component: AllList
    // }, {
    //   name: 'mine',
    //   path: 'mine',
    //   component: MyList
    // }]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
